import basicController from "servicestack/basic.controller.properties";
import prompt from "emun.vendor/vendor-edit";

export default class VendorDashboardToolbarController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
  }
  runReport(name) {
    const $ctrl = this;
    var filter = $ctrl.$session.vendorGroup
      ? "?VendorGroup=" + $ctrl.$session.vendorGroup
      : "?VendorId=" + $ctrl.vendorId;
    let url = $ctrl.$appConfig.resolveServiceUrl(name + filter);
    return (location.href = url);
  }
  exportQuickReport(report) {
    const $ctrl = this;

    var filter = $ctrl.$session.vendorGroup
      ? "&@VendorGroup=" + $ctrl.$session.vendorGroup
      : "&@VendorID=" + $ctrl.vendorId;

      let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        report.name +
        " &output=xlsx&QuickReportID=" +
        report.id +
        "&QuickReportName=" +
        report.name + filter
    );
    return (location.href = url);
  }
  edit() {
    const $ctrl = this;
    return prompt
      .open({
        title: $ctrl.vendor.id + " - " + $ctrl.vendor.vendorName + " Edit...",
        vendor: $ctrl.vendor,
      })
      .then(function () {
        $ctrl.query.load(true);
      });
  }
}
